import { useMemo } from 'react';
// import { SearchInput } from '../../SearchInput';
import type { TeamMembersUser } from '../../../lib/types/TeamMembersUser';
import { AvatarInitials } from '../../AvatarInitials';
import { NamedContentEntryText } from '../../ContentEntryText/NamedContentEntryText';
import { formatNumberWithCommas } from '../../../lib/numbers/formatNumberWithComma';
import { Icon, IconType } from '../../Props/Icon/Icon';
import { UserOptionsMenu } from '../components/UserOptionsMenu';
import { ProgressBar, ProgressFill } from '../../Activity/components/TrainingCard';
import styled from 'styled-components';
// import { useNamedContentEntryText } from '../../../lib/hooks/contentEntry/useNamedContentEntryText';
import { Ellipsis } from '../../utility/Ellipsis';

export const useTeamMembersColumns = (
  nameSearchInputValue: string,
  handleNameSearchChange: (searchTerm: string) => void,
) => {
  // const namePlaceholder = useNamedContentEntryText({ refKey: 'managerTeamMembers', subKey: 'name' }) || '';

  // TODO: Remove after search functionality is ready
  console.log(nameSearchInputValue, handleNameSearchChange);
  return useMemo(
    () => [
      {
        header: (
          // TODO: Uncomment after search functionality is ready
          // <SearchInput
          //   value={nameSearchInputValue}
          //   onChange={handleNameSearchChange}
          //   placeholder={namePlaceholder}
          //   withSearchIcon
          // />
          <NamedContentEntryText refKey="managerTeamMembers" container="span" subKey="name" />
        ),
        valueSelector: (user: TeamMembersUser) => (
          <UserName>
            {user.avatar ? (
              <UserImg src={`data:image/png;base64,${user.avatar}`} />
            ) : (
              <AvatarInitials name={user.name || ''} id={user.name ?? ''} size="32px" />
            )}
            <Ellipsis>{user.name}</Ellipsis>
          </UserName>
        ),
      },
      {
        header: <NamedContentEntryText refKey="managerTeamMembers" container="span" subKey="jobTitle" />,
        valueSelector: (user: TeamMembersUser) => user.jobTitle,
      },
      {
        header: <NamedContentEntryText refKey="managerTeamMembers" container="span" subKey="department" />,
        valueSelector: (user: TeamMembersUser) => user.departmentId,
      },
      {
        header: <NamedContentEntryText refKey="managerTeamMembers" container="span" subKey="cyberIq" />,
        valueSelector: (user: TeamMembersUser) => (
          <UserPoints className="user-points">
            <Icon width={20} height={20} icon={IconType.COIN} /> {formatNumberWithCommas(user.cyberIqPoints)}
          </UserPoints>
        ),
      },
      {
        header: <NamedContentEntryText refKey="managerTeamMembers" container="span" subKey="training" />,
        valueSelector: (user: TeamMembersUser) => {
          const progress = user.trainings ? (user.trainings.completed / user.trainings.assigned) * 100 : 0;
          return (
            <ProgressBar>
              <ProgressFill progress={progress} />
            </ProgressBar>
          );
        },
        width: '150px',
      },
      {
        header: '',
        valueSelector: () => <UserOptionsMenu />,
        width: '36px',
      },
    ],
    [],
  );
};

const UserName = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: ${({ theme }) => theme.fontSizes.normal};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.heading};
`;

const UserImg = styled.img`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;
`;

const UserPoints = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  display: flex;
  align-items: center;
  gap: 8px;
`;
